module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="page-header">\n	<h4 class="title">Whats new</h4>\n</div>\n<div class="page-content">\n	<div class="section">\n		<h5>There are two main changes to NRL Tipping in 2020:</h5>\n		<p>• The nine games of the 2020 NRL Finals series will constitute Round 26</p>\n		<p>• The Streak competition will be a knock-out competition and start in Round 8</p>\n	</div>\n</div>';
}
return __p;
};
